module.exports = __webpack_public_path__ + "img/hamburger.abf25760.svg";